import {
  defineNuxtRouteMiddleware,
  navigateTo,
  useRequestHeaders,
} from '#imports'

import { HttpHeader } from '@backmarket/http-api'

import { toWebviewRouteName } from '../utils'

/* eslint-disable consistent-return */
export default defineNuxtRouteMiddleware((to, from) => {
  if (!to.name?.toString()) return
  if (to.meta?.isWebview) return

  const headers = useRequestHeaders()
  const userAgent =
    headers[HttpHeader.USER_AGENT] ?? window?.navigator?.userAgent

  // Redirect links within the webview version to their webview version
  if (!to.meta?.isWebview && from.meta?.isWebview) {
    return navigateTo({
      name: toWebviewRouteName(String(to.name)),
      params: to.params,
      query: to.query,
    })
  }

  // Redirect to the webview version when the user agent contains the keyword
  if (userAgent?.includes('bm-mobile-app-webview')) {
    return navigateTo({
      name: toWebviewRouteName(String(to.name)),
      params: to.params,
      query: to.query,
    })
  }
})
